<div class="container animated fadeInRight" *ngIf="!mostrarFormulario">
  <app-lfsa-card [innTemplate]="grid" [titulo]="'Mantenimiento de Aplicaciones La Fabril'" [efecto]="true" [colapseName]="'grid'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #grid>
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div [class]="'col-md-12'">
            <label><b><h3>Ingresar Aplicación</h3></b></label>
          </div>
        </div>
        <form [formGroup]="formulario" novalidate class="form-group">
          <div class="row">
            <div [class]="'col-md-12'">
              <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('appDesc')"
                [placeholder]="'Descripción'" formControlName="appDesc" [label]="'Ingrese Descripción*'" [type]="'text'" [id]="'appDesc'">
              </app-lfsa-input>
            </div>
            <div [class]="'col-md-12'">
              <app-lfsa-combo-box [mostrarImg]="false" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbTipoApp" 
                formControlName="tipoApp" [control]="formulario.get('tipoApp')" [claseLabel]="'letrasDanger'" [label]="'Tipo Aplicación*'" [id]="'tipoApp'">
              </app-lfsa-combo-box>
            </div>
            <div [class]="'col-md-12'">
              <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
              <div *ngIf="!loading">
                <label>&nbsp;</label><br>
                <button class="btn btn-success btn-block" [disabled]="formulario.invalid"
                  (click)="crearAplicacion()">Guardar</button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="col-md-6">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
            No existen datos para la lista de Aplicaciones.
          </div>
          <div *ngIf="!listaVacia">
            <div class="row">
              <div [class]="'col-md-12'">
                <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
                  (keyup)="onQuickFilterChanged()" #quickFilter />
              </div>
            </div>
            <br>
            <hr>
            <ag-grid-angular #agGrid class=" {{uniformeModulo.agGrid.class}}" [ngStyle]="uniformeModulo.agGrid.style"
              id="{{uniformeModulo.agGrid.id}}" [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs"
              [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
              >
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
<br>


<!-- MODAL EDITAR APLICACION -->
<app-lfsa-modal [innTemplate]="enviarModalReport" [titulo]="'Actualizar Aplicación'" [idButton]="'abrirModalEditar'" [idOpen]="'ModalEditar'"
  [idClose]="'cerrarModalEditar'"></app-lfsa-modal>
<ng-template #enviarModalReport>
  <form [formGroup]="formularioEditar" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formularioEditar.get('appDesc')"
          [placeholder]="'Descripción'" formControlName="appDesc" [label]="'Ingrese Descripción*'" [type]="'text'" [id]="'appDesc'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-combo-box [mostrarImg]="false" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbTipoApp" 
          formControlName="tipoApp" [control]="formularioEditar.get('tipoApp')" [claseLabel]="'letrasDanger'" [label]="'Tipo Aplicación*'" [id]="'tipoApp'">
        </app-lfsa-combo-box>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioEditar.invalid"
            (click)="updateAplicacion()">Actualizar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>